class TradeRegisterForm {
  constructor() {
    this.form = document.querySelector('.trade-register form');
    this.submitButton = document.getElementById('TradeRegisterSubmit');
    this.termsCheckbox = document.getElementById('TradeTerms');
    this.tradeTermsCheckbox = document.getElementById('TradeTermsAgreement');
    this.termsError = document.getElementById('TradeRegisterForm-terms-error');
    this.tradeTermsError = document.getElementById('TradeRegisterForm-trade-terms-error');
    
    this.init();
  }

  init() {
    if (this.submitButton) {
      this.submitButton.addEventListener('click', (e) => this.validateForm(e));
    }

    if (this.termsCheckbox) {
      this.termsCheckbox.addEventListener('change', () => this.toggleTermsError());
    }

    if (this.tradeTermsCheckbox) {
      this.tradeTermsCheckbox.addEventListener('change', () => this.toggleTradeTermsError());
    }

    this.setupPasswordValidation();
    this.setupPhoneValidation();
  }

  validateForm(e) {
    let hasError = false;
    
    if (!this.termsCheckbox?.checked) {
      this.showTermsError();
      hasError = true;
    }
    
    if (!this.tradeTermsCheckbox?.checked) {
      this.showTradeTermsError();
      hasError = true;
    }
    
    if (hasError) {
      e.preventDefault();
      this.scrollToFirstError();
      return false;
    }
  }

  showTermsError() {
    if (this.termsError) {
      this.termsError.style.display = 'block';
    }
  }

  showTradeTermsError() {
    if (this.tradeTermsError) {
      this.tradeTermsError.style.display = 'block';
    }
  }

  toggleTermsError() {
    if (this.termsError) {
      this.termsError.style.display = this.termsCheckbox?.checked ? 'none' : 'block';
    }
  }

  toggleTradeTermsError() {
    if (this.tradeTermsError) {
      this.tradeTermsError.style.display = this.tradeTermsCheckbox?.checked ? 'none' : 'block';
    }
  }

  scrollToFirstError() {
    const firstError = document.querySelector('.trade-register .form__message[style*="display: block"]');
    if (firstError) {
      firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  setupPasswordValidation() {
    const passwordField = document.getElementById('TradeRegisterForm-password');
    if (passwordField) {
      passwordField.addEventListener('input', (e) => {
        const password = e.target.value;
        const minLength = 8;
        
        if (password.length > 0 && password.length < minLength) {
          e.target.setCustomValidity(`Password must be at least ${minLength} characters long`);
        } else {
          e.target.setCustomValidity('');
        }
      });
    }
  }

  setupPhoneValidation() {
    const phoneField = document.getElementById('TradeRegisterForm-phone');
    if (phoneField) {
      phoneField.addEventListener('input', (e) => {
        let phone = e.target.value.replace(/\D/g, '');
        
        if (phone.length > 0) {
          if (phone.length < 10) {
            e.target.setCustomValidity('Please enter a valid phone number');
          } else {
            e.target.setCustomValidity('');
          }
        }
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.trade-register')) {
    new TradeRegisterForm();
  }
}); 